import { AdminRegistrationCode } from "src/Types/auth.types";

export { formatDate } from "src/i18n/format";

export type KeyStatus = "active" | "revoked" | "expired";

export const keyStatus = (
  code: AdminRegistrationCode,
  now = Date.now()
): KeyStatus => {
  if (code.revokedAt) return "revoked";
  if (code.expiresAt && new Date(code.expiresAt).getTime() <= now) {
    return "expired";
  }
  return "active";
};
